import { Button } from '@mui/material';
import { Link } from 'react-router';

interface CategoryButtonProps {
  category: { name: string; path: string };
  variant?: 'contained' | 'text' | 'outlined';
  onClick?: () => void;
}

export default function LinkCategoryButton({
  category,
  variant = 'contained',
}: Readonly<CategoryButtonProps>) {
  return (
    <Button
      component={Link}
      to={category.path}
      size={'medium'}
      variant={variant}
      sx={{
        paddingY: 1,
        paddingX: 2,
      }}
      key={category.name}
    >
      {category.name}
    </Button>
  );
}
